import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
	setMultiAutostash,
	setBankLinkOAuth,
	setScheduleAmount,
	setScheduleFrequency,
	eSigNextStep,
	skipToLinkBankPrimer,
} from 'stash/actions';
import {
	getAutoStashConfig,
	deleteAutoStashConfig,
	getSkipToBankLinkConfig,
	deleteSkipToBankLinkConfig,
} from './utils';
import { Loader } from '@stashinvest/ui';

/**
 * when a user goes through the oauth flow for Plaid they will be reentering the graph
 * after the autostash configuration, in order for us to properly set the stored auto stash
 * from the current session, we need to reconfigure the multi funding as though
 * they had gone through a non-oauth flow
 */

const mapDispatchToProps = (dispatch) => ({
	setMultiAutostash: (data) => {
		return dispatch(setMultiAutostash(data));
	},
	setBankLinkRedirectUri: () => {
		return dispatch(setBankLinkOAuth(false));
	},
});

const BankLinkOAuth = ({ setMultiAutostash, setBankLinkRedirectUri }) => {
	const [configComplete, setConfigComplete] = useState(false);
	const dispatch = useDispatch();
	const storedAutoStashConfig = getAutoStashConfig();
	const storedSkipToBankLinkConfig = getSkipToBankLinkConfig();

	useEffect(() => {
		if (!configComplete) {
			setBankLinkRedirectUri();
			if (storedAutoStashConfig) {
				try {
					/**
					 * Set Redux values for DAG transitions
					 */
					dispatch(setScheduleAmount(storedAutoStashConfig?.amount));
					dispatch(setScheduleFrequency(storedAutoStashConfig?.frequency));
					dispatch(eSigNextStep(storedAutoStashConfig?.eSigNextStep));
				} catch (error) {
					console.log(error);
				}
			} else if (storedSkipToBankLinkConfig) {
				try {
					/**
					 * Set Redux values for DAG transitions
					 */
					dispatch(skipToLinkBankPrimer(storedSkipToBankLinkConfig?.skipToBankLink));
				} catch (error) {
					console.log(error);
				}
			}

			setConfigComplete(true);
		}
	}, [
		configComplete,
		setConfigComplete,
		setBankLinkRedirectUri,
		setMultiAutostash,
		storedAutoStashConfig,
		storedSkipToBankLinkConfig,
		dispatch,
	]);

	return configComplete ? (
		<Redirect to={{ pathname: '/sign-up/link-bank' }} />
	) : (
		<Loader center />
	);
};

BankLinkOAuth.propTypes = {
	setMultiAutostash: PropTypes.func,
	setBankLinkRedirectUri: PropTypes.func,
};

export default connect(null, mapDispatchToProps)(BankLinkOAuth);
